import {
  clearParkingConversation,
  startParkingConversation,
} from "../../../../Components/Actions/ParkingActions";
import uhaulStore from "../../../../CustomRedux/UhaulStore";

const PARKING_WAIT_INTERVAL_MS = 2000;
const PARKING_MAX_RETRIES = 5;

const markConversationAsParking = (conversationSid: string) => {
  if (conversationSid) {
    uhaulStore.dispatch(startParkingConversation(conversationSid));
  }
};

const clearConversationParking = (conversationSid: string) => {
  if (conversationSid) {
    uhaulStore.dispatch(clearParkingConversation(conversationSid));
  }
};

const isConversationParking = (conversationSid: string) => Boolean(
  conversationSid &&
  uhaulStore.getState().UhaulReducer.parkingConversations?.[conversationSid]
);

const waitForParkingToFinish = async (conversationSid: string) => {
  let attempts = 0;

  while (isConversationParking(conversationSid) && attempts < PARKING_MAX_RETRIES) {
    await new Promise((resolve) => setTimeout(resolve, PARKING_WAIT_INTERVAL_MS));
    attempts += 1;
  }

  return !isConversationParking(conversationSid);
};

export default {
  clearConversationParking,
  isConversationParking,
  markConversationAsParking,
  waitForParkingToFinish,
};